import * as React from 'react';

import styled from '@emotion/styled';

const Svg = styled.svg`
  width: 24px;
  height: 24px;
  margin-right: 0.5rem;
`;

const CPUIcon = () => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg">
        <g transform="translate(-36.012 -36.004)" fill="#4694ce">
            <rect width="2.089" height="3.134" rx="1" transform="translate(51.655 56.87)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(48.521 56.87)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(45.414 56.87)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(42.28 56.87)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(36.012 51.647)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(36.012 48.513)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(36.012 45.406)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(36.012 42.272)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(56.878 51.647)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(56.878 48.513)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(56.878 45.406)" />
            <rect width="3.134" height="2.089" rx="1" transform="translate(56.878 42.272)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(51.655 36.004)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(48.521 36.004)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(45.414 36.004)" />
            <rect width="2.089" height="3.134" rx="1" transform="translate(42.28 36.004)" />
            <path d="M54.12 40.183H41.904a1.714 1.714 0 00-1.714 1.714v12.215a1.714 1.714 0 001.714 1.714H54.12a1.714 1.714 0 001.714-1.714V41.897a1.715 1.715 0 00-1.714-1.714zm-1.716 12.214H43.62v-8.785h8.784z" />
        </g>
    </Svg>
  );
};

export default CPUIcon;
